
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popular-products",
      function () {
        return require("private-next-pages/popular-products/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/popular-products"])
      });
    }
  